"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplePayService = void 0;
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
class ApplePayService extends Base_1.BaseService {
    validateMerchant(accountId, data) {
        return this.request({
            url: (0, apiRoutes_1.applePayValidateMerchantUrl)(accountId),
            method: 'post',
            data,
        });
    }
}
exports.ApplePayService = ApplePayService;
//# sourceMappingURL=index.js.map